import React from "react";
import { Flex } from "antd";
import { PlusCircleFilled, PlusOutlined } from "@ant-design/icons";
import {
    CustomTitle,
    CustomButton,
  } from "../../components";
import LinkIcon from "../../assets/images/link-icon.svg";
import EmptyShipmentBg from "../../assets/images/empty-shipment-bg.svg";
import EmptyShipmentBox from "../../assets/images/empty-shipment-box.svg";

const EmptyShipments = ({ handleConnectButtonClick, handleShipmentFormModal, userRole, allPermissions }) => {
  return (
    <Flex justify="center" align="flex-start">
      <Flex
        gap={12}
        vertical={true}
        style={{
          maxWidth: "556px",
          textAlign: "center",
          paddingTop: "40px",
        }}
      >
        <div
          className="empty-shipment-icon"
          style={{ position: "relative", height: "228px" }}
        >
          <div
            className="bg"
            style={{
              backgroundImage: `url(${EmptyShipmentBg})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              textAlign: "center",
              width: "324px",
              height: "inherit",
              margin: "0 auto",
              position: "relative",
              backgroundSize: "contain",
            }}
          >
            <img
              src={EmptyShipmentBox}
              alt=""
              style={{ position: "relative", bottom: "30px" }}
            />

            <Flex
              align="center"
              justify="center"
              style={{
                width: "64px",
                height: "64px",
                borderRadius: "50%",
                backgroundColor: "#fff",
                position: "absolute",
                bottom: "33px",
                right: "30px",
                cursor: "pointer",
              }}
            >
              <PlusCircleFilled
                style={{ fontSize: "32px", color: "#266EF1" }}
              />
            </Flex>
          </div>
        </div>

        <CustomTitle
          text={"You're not tracking any shipments yet"}
          fontSize={28}
          fontWeight={700}
          lineHeight={"36px"}
          color={"#000"}
          marginBottom={0}
        />

        <CustomTitle
          text={
            "To start tracking your shipments, connect your transport providers, or manually enter your shipment tracking IDs."
          }
          fontSize={16}
          fontWeight={400}
          lineHeight={"24px"}
          color={"#000"}
          marginBottom={0}
          marginTop={0}
        />

        {/* {userRole?.toLowerCase() !== "viewer" && ( */}
          <Flex wrap gap={8} align="center" justify="center">
            <CustomButton
              onClick={handleConnectButtonClick}
              height="48px"
              minWidth="204px"
              fontSize="16px"
              text={"Connect providers"}
              bgColor="#F3F3F3"
              borderRadius="40px"
              color="#000"
              boxShadow="none"
              iconPosition="left"
              image={LinkIcon}
              gap="10px"
              lineHeight={"20px"}
              fontWeight={600}
            />
                  {allPermissions?.is_create && 

            <CustomButton
              onClick={handleShipmentFormModal}
              height="48px"
              minWidth="178px"
              fontSize="16px"
              text={"Track manually"}
              bgColor="#F3F3F3"
              borderRadius="40px"
              color="#000"
              boxShadow="none"
              iconPosition="left"
              icon={<PlusOutlined />}
              gap="10px"
              lineHeight={"20px"}
              fontWeight={600}
            />
                  }
          </Flex>
        {/* )} */}
      </Flex>
    </Flex>
  );
};

export default EmptyShipments;
